"use client"

import { Helmet } from "react-helmet-async"
import { ArrowRight, BookOpen, Building2, FileText } from "lucide-react"
import { Button } from "../../components/ui/button"
import { useNavigate } from "react-router-dom"

import logoAUF from "../../assets/Partnerlogo/agence-universitaire-de-la-francophonie-logo-png_seeklogo-236447.png"
import logoCEDECA from "../../assets/Partnerlogo/cedeca-logo-2-122x141.png"
import logoCFCIB from "../../assets/Partnerlogo/CFCIB logo.webp"
import logoCORILAC from "../../assets/Partnerlogo/corilac.jpeg"
import logoAMEBE from "../../assets/Partnerlogo/cropped-LOGO-AMEBE.jpg"
import logoENS from "../../assets/Partnerlogo/ENS.jpg"
import logoHMK from "../../assets/Partnerlogo/Hopital militaire Kamenge.png"
import logoIBB from "../../assets/Partnerlogo/interbank.png"
import logoIFDC from "../../assets/Partnerlogo/International Fertilizer Development Center (IFDC).webp"
import logoJimbere from "../../assets/Partnerlogo/jimbere.jpg"
import logoKDU from "../../assets/Partnerlogo/KYUNGDONG UNIVERSITY.png"
import logoFEBABU from "../../assets/Partnerlogo/LOGO FEBABU_Plan de travail 1.png"
import logoKomera from "../../assets/Partnerlogo/Komera.webp"
import logoMUST from "../../assets/Partnerlogo/Mbarara University of Science and Technology.webp"
import logoUN from "../../assets/Partnerlogo/Nations unies.png"
import logoRSHU from "../../assets/Partnerlogo/RSHU_logo.png"
import logoTeramo from "../../assets/Partnerlogo/universita-degli-studi-di-teramo.jpg"
import logoUB from "../../assets/Partnerlogo/universite du burundi.png"
import logoEmbu from "../../assets/Partnerlogo/University-of-Embu_Logo.jpg"
import logoParma from "../../assets/Partnerlogo/Università di Parma.png"
import logoFH from "../../assets/Partnerlogo/FH-Logo-Color-Web.jfif"
import logoStamm from "../../assets/Partnerlogo/Fandation Stamm.avif"
import logoEU from "../../assets/Partnerlogo/eu_flag.jpg"
import logoUS from "../../assets/Partnerlogo/Us.jfif"

const PARTNER_LOGOS = [
  { src: logoUS, name: "États-Unis" },
  { src: logoEU, name: "Union Européenne" },
  { src: logoAUF, name: "AUF", url: "https://www.auf.org" },
  { src: logoUB, name: "Université du Burundi", url: "https://www.ub.edu.bi" },
  { src: logoTeramo, name: "Teramo University", url: "https://www.unite.it" },
  { src: logoMUST, name: "MUST", url: "https://www.must.ac.ug" },
  { src: logoUN, name: "Nations Unies", url: "https://www.un.org/fr" },
  { src: logoKDU, name: "KyngDong University", url: "https://www.kdu.ac.kr" },
  { src: logoParma, name: "Università di Parma", url: "https://www.unipr.it" },
  { src: logoEmbu, name: "University of Embu", url: "https://www.embu.ac.ke" },
  { src: logoRSHU, name: "Université Hydrométéorologique Russe", url: "https://www.meteo.ru" },
  { src: logoENS, name: "ENS", url: "https://www.ens.bi" },
  { src: logoHMK, name: "Hôpital Militaire de Kamenge", url: "https://www.hmkamenge.bi/" },
  { src: logoIFDC, name: "IFDC", url: "https://ifdc.org" },
  { src: logoCFCIB, name: "CFCIB", url: "https://www.cfcib.bi" },
  { src: logoCEDECA, name: "CEDECA", url: "https://cedeca.bi" },
  { src: logoAMEBE, name: "AMEBE", url: "https://amebe.org" },
  { src: logoIBB, name: "InterBanque Burundi", url: "https://interbankbdi.bi/" },
  { src: logoCORILAC, name: "CORILAC", url: "http://www.corilacmicrofinance.bi/" },
  { src: logoFEBABU, name: "FEBABU", url: "https://www.fefabu.com" },
  { src: logoKomera, name: "Komera" , url: "https://www.komera.es" },
  { src: logoJimbere, name: "Jimbere Magazine", url: "https://www.jimberemag.org" },
  { src: logoFH, name: "Food for the Hungry", url: "https://www.fh.org" },
  { src: logoStamm, name: "Fondation Stamm", url: "https://stammfoundation.org" },
]

const SIGLES = [
  { sigle: "AMEBE", designation: "Association of Mentors for Business and Entrepreneurship" },
  { sigle: "ASU", designation: "Asociación por la Solidaridad Universitaria" },
  { sigle: "AUF", designation: "Agence Universitaire de la Francophonie" },
  { sigle: "CEDECA", designation: "Centre de Développement des Carrières" },
  { sigle: "CFCIB", designation: "Chambre Fédérale de Commerce et Industrie du Burundi" },
  { sigle: "ENS", designation: "École Normale Supérieure" },
  { sigle: "FEFABU", designation: "Fédération de Basketball du Burundi" },
  { sigle: "HMK", designation: "Hôpital Militaire de Kamenge" },
  { sigle: "IBB", designation: "InterBanque Burundi" },
  { sigle: "IFDC", designation: "International Fertilizer Development Center" },
  { sigle: "IPI", designation: "Institut de Professionnalisation pour les Innovations" },
  { sigle: "KDU", designation: "KyngDong University" },
  { sigle: "MUST", designation: "Mbarara University of Science and Technology" },
  { sigle: "SCTA", designation: "Société de Commercialisation et de Transformation Alimentaire" },
  { sigle: "UNG", designation: "Université de Ngozi" },
]

const PARTENARIATS_ACADEMIQUES = [
  { n: 1, convention: "UNG – Université du Burundi", objectif: "Mise en œuvre de la réforme BMD", date: "22/12/2016 — avenant 19/10/2022", duree: "5 ans renouvelables" },
  { n: 2, convention: "UNG – ENS", objectif: "Collaboration en recherche et développement", date: "20/10/2022", duree: "5 ans renouvelables" },
  { n: 3, convention: "UNG – ENS (Accès infrastructures sportives)", objectif: "Accès aux infrastructures sportives", date: "30/11/2024", duree: "3 ans renouvelables" },
  { n: 4, convention: "UNG – Teramo University (Italie)", objectif: "Coopération scientifique et culturelle", date: "05/06/2020", duree: "Conventionnelle" },
  { n: 5, convention: "UNG – AUF", objectif: "Fourniture matériel d'interprétation", date: "03/11/2020", duree: "Conventionnelle" },
  { n: 6, convention: "UNG – HMK", objectif: "Collaboration en formation médicale", date: "26/11/2020", duree: "Indéterminée" },
  { n: 7, convention: "UNG – MUST (Ouganda)", objectif: "Coopération en éducation et santé", date: "13/01/2021", duree: "5 ans renouvelables" },
  { n: 8, convention: "UNG – Université Hydrométéorologique Russe", objectif: "Partenariat stratégique", date: "05/11/2021", duree: "Conventionnelle" },
  { n: 9, convention: "UNG – Nations Unies", objectif: "Coopération générale", date: "Février 2023", duree: "Conventionnelle" },
  { n: 10, convention: "UNG – Parma University (Italie)", objectif: "Éducation, culture, recherche", date: "Mai 2023", duree: "Conventionnelle" },
  { n: 11, convention: "UNG – Hôpital Renato Monolo", objectif: "Collaboration médicale", date: "10/06/2024", duree: "1 an renouvelable" },
  { n: 12, convention: "UNG – Université d'Embu (Kenya)", objectif: "Coopération académique et mentorat", date: "Septembre 2024", duree: "5 ans renouvelables" },
  { n: 13, convention: "UNG – KDU (Corée)", objectif: "Coopération académique", date: "Juillet 2023", duree: "5 ans renouvelables" },
]

const PARTENARIATS_INSTITUTIONNELS = [
  { n: 1, convention: "UNG – Food for the Hungry", objectif: "Étude sur la sécurité alimentaire", date: "09/09/2020" },
  { n: 2, convention: "UNG – IMENA", objectif: "Coopération en recherche et technologie", date: "22/09/2020" },
  { n: 3, convention: "UNG – Burundi Brewery", objectif: "Recherche appliquée et technologie", date: "23/09/2020" },
  { n: 4, convention: "UNG – SCTA", objectif: "Recherche et formation professionnelle", date: "12/10/2020" },
  { n: 5, convention: "UNG – Fondation Stamm", objectif: "Réduction de la malnutrition", date: "03/11/2020" },
  { n: 6, convention: "UNG – IPI Consult", objectif: "Recherche, formation et renforcement", date: "20/11/2020" },
  { n: 7, convention: "UNG – CFCIB", objectif: "Prestations de services pour entreprises", date: "12/01/2021" },
  { n: 8, convention: "UNG – ASU", objectif: "Formation des jeunes Batwa", date: "13/01/2021" },
  { n: 9, convention: "UNG – Association Basketball Ngozi", objectif: "Promotion du sport universitaire", date: "10/06/2021" },
  { n: 10, convention: "UNG – Jimbere Magazine", objectif: "Collaboration académique", date: "13/12/2021" },
  { n: 11, convention: "UNG – Lycée Don Bosco", objectif: "Promotion de la paix par le sport", date: "25/10/2022" },
  { n: 12, convention: "UNG – CEDECA", objectif: "Employabilité et entrepreneuriat", date: "08/11/2022" },
  { n: 13, convention: "UNG – IFDC", objectif: "Recherche sur la valorisation des déchets", date: "Conventionnelle" },
  { n: 14, convention: "UNG – CORILAC Microfinance", objectif: "Divers domaines de coopération", date: "—" },
  { n: 15, convention: "UNG – AMEBE", objectif: "Vulgarisation des découvertes et innovation", date: "05/09/2024" },
  { n: 16, convention: "UNG – Local Service Security", objectif: "Surveillance et gardiennage", date: "01/10/2024" },
  { n: 17, convention: "UNG – IBB", objectif: "Utilisation du produit IBB M+", date: "16/05/2025" },
]

const ORGANES = [
  "L'Assemblée Générale",
  "Le Comité Exécutif",
  "Le Conseil de Surveillance",
  "Le Conseil Rectoral",
  "Le Conseil Académique",
  "Le Conseil Scientifique",
  "Le Conseil des Facultés et Instituts",
]

export default function Partenariats() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-background font-sans text-foreground">
      <Helmet>
        <title>Conventions de Partenariat - Université de Ngozi</title>
        <meta name="description" content="Conventions et memoranda d'entente de l'Université de Ngozi avec institutions locales, nationales et internationales. Partenariats académiques et institutionnels." />
      </Helmet>

      {/* Hero */}
      <header className="relative min-h-[50vh] flex items-center bg-primary overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-primary via-primary to-primary/95" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_80%_50%_at_70%_40%,rgba(255,255,255,0.06),transparent)]" />
        <div className="container relative z-10 py-16">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-4 mb-6">
              <span className="text-[10px] uppercase tracking-[0.3em] text-accent font-black">Coopération</span>
              <div className="h-px w-12 bg-accent/50" />
              <span className="text-[10px] text-primary-foreground/60 uppercase tracking-widest font-bold">Conventions & Memoranda</span>
            </div>
            <h1 className="heading-1 mb-6 leading-[0.95] font-serif tracking-tight text-white">
              <span className="block italic font-light text-accent/90">Les Conventions de Partenariat</span>
              <span className="block text-white mt-2">entre l'UNG et les Autres Institutions</span>
            </h1>
            <p className="text-lg text-primary-foreground/90 max-w-2xl">
              Partenariats académiques, scientifiques et institutionnels au service du développement et de l'excellence.
            </p>
          </div>
        </div>
      </header>

      <div className="container max-w-5xl mx-auto px-6 lg:px-8 py-16 lg:py-24">
        {/* In-page navigation */}
        <nav className="mb-12 pb-8 border-b border-border" aria-label="Sections de la page">
          <p className="text-[11px] uppercase tracking-[0.2em] font-bold text-muted-foreground mb-4">Sur cette page</p>
          <ul className="flex flex-wrap gap-x-6 gap-y-2 text-sm">
            {PARTNER_LOGOS.length > 0 && <li><a href="#partner-logos" className="text-primary hover:text-accent hover:underline font-medium">Logos partenaires</a></li>}
            <li><a href="#cadre-institutionnel" className="text-primary hover:text-accent hover:underline font-medium">Cadre institutionnel</a></li>
            <li><a href="#sigles" className="text-primary hover:text-accent hover:underline font-medium">Sigles</a></li>
            <li><a href="#partenariats-academiques" className="text-primary hover:text-accent hover:underline font-medium">Partenariats académiques</a></li>
            <li><a href="#partenariats-institutionnels" className="text-primary hover:text-accent hover:underline font-medium">Partenariats institutionnels</a></li>
          </ul>
        </nav>

        {/* Introduction */}
        <section className="mb-20">
          <div className="mb-6">
            <span className="text-[11px] uppercase tracking-[0.3em] font-bold text-accent">Introduction</span>
          </div>
          <div className="space-y-4 text-muted-foreground leading-relaxed text-lg">
            <p>
              L'Université de Ngozi est une institution d'enseignement supérieur de type communautaire et privé, créée en 1999 sous forme d'ASBL et agréée par l'ordonnance ministérielle n° 610/650 du 22 octobre 1999. Son objectif principal est de contribuer à l'amélioration des conditions de vie des populations et à la réduction de la pauvreté à travers une formation universitaire de qualité, la recherche fondamentale et appliquée, et l'innovation.
            </p>
            <p>
              L'Université forme des cadres moyens et supérieurs capables d'appréhender les problématiques de leurs milieux professionnels, de proposer des solutions adaptées, de contribuer au développement durable et de participer à l'éducation morale et humaine de la jeunesse.
            </p>
            <p>
              Créée grâce aux efforts conjoints de la population de la province Ngozi, d'associations, de particuliers et de communautés religieuses, l'Université de Ngozi est une institution engagée politiquement et socialement dans la promotion de la paix, de la réconciliation nationale, du savoir et du développement.
            </p>
          </div>
        </section>

        {PARTNER_LOGOS.length > 0 && (
          <section className="mb-20 scroll-mt-24" id="partner-logos">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-12 h-1 bg-accent rounded-full" />
              <span className="text-[11px] uppercase tracking-[0.3em] font-bold text-accent">Nos Partenaires</span>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
              {PARTNER_LOGOS.map(({ src, name, url }) => {
                const cardContent = (
                  <>
                    <div className="w-full h-24 flex items-center justify-center mb-3 overflow-hidden">
                      <img
                        src={src}
                        alt={name}
                        className="max-h-full max-w-full w-auto object-contain group-hover:grayscale-0 opacity-80 group-hover:opacity-100 transition-all duration-300"
                      />
                    </div>
                    <span className="text-xs font-medium text-muted-foreground text-center line-clamp-2 group-hover:text-foreground transition-colors">
                      {name}
                    </span>
                  </>
                )
                const cardClass = "group flex flex-col items-center justify-center p-6 rounded-xl border border-border bg-card hover:border-primary/40 hover:shadow-lg hover:shadow-primary/5 transition-all duration-300 min-h-[160px]"
                return (
                  <div key={name} className={cardClass}>
                    {url ? (
                      <a
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex flex-col items-center justify-center w-full h-full text-inherit no-underline focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded-xl"
                        title={`Visiter ${name} (nouvel onglet)`}
                      >
                        {cardContent}
                      </a>
                    ) : (
                      cardContent
                    )}
                  </div>
                )
              })}
            </div>
          </section>
        )}

        {/* Cadre institutionnel - résumé avec liens */}
        <section className="mb-20 scroll-mt-24" id="cadre-institutionnel">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-1 bg-primary rounded-full" />
            <span className="text-[11px] uppercase tracking-[0.3em] font-bold text-primary">Cadre institutionnel</span>
          </div>
          <h2 className="text-2xl font-serif font-bold text-foreground mb-8">Cadre Institutionnel et Organisationnel de l'Université</h2>

          <div className="space-y-10">
            <div>
              <h3 className="text-lg font-bold text-foreground mb-2">I.1. Vision de l'Université</h3>
              <p className="text-muted-foreground leading-relaxed mb-3">
                Former des cadres de moyen et de haut niveau, capables d'appréhender les problèmes des différents milieux où ils seront appelés à œuvrer, de trouver des solutions appropriées et de contribuer à un développement durable ainsi qu'à l'éducation morale et humaine de la société.
              </p>
              <Button variant="ghost" size="sm" onClick={() => navigate("/mission")} className="text-primary p-0 h-auto font-semibold">
                Mission & Vision complètes <ArrowRight className="w-4 h-4 ml-1 inline" />
              </Button>
            </div>

            <div>
              <h3 className="text-lg font-bold text-foreground mb-2">I.2. Missions de l'Université</h3>
              <p className="text-muted-foreground leading-relaxed mb-2">L'Université de Ngozi s'est donnée pour missions de :</p>
              <ul className="list-disc list-inside text-muted-foreground space-y-1 mb-3">
                <li>Contribuer à l'éducation à la paix et à la réconciliation nationale.</li>
                <li>Offrir un avenir plein d'espoir à la jeunesse burundaise et régionale.</li>
                <li>Offrir des formations universitaires de niveau baccalauréat, master et doctorat.</li>
                <li>Promouvoir la recherche appliquée et fondamentale dans les secteurs clés du développement socio-économique.</li>
              </ul>
              <Button variant="ghost" size="sm" onClick={() => navigate("/mission")} className="text-primary p-0 h-auto font-semibold">
                En savoir plus <ArrowRight className="w-4 h-4 ml-1 inline" />
              </Button>
            </div>

            <div>
              <h3 className="text-lg font-bold text-foreground mb-2">I.3. Valeurs de l'Université</h3>
              <p className="text-muted-foreground leading-relaxed mb-3">
                Engagement à la paix et à la multiculturalité ; recherche de l'intégration sociale ; vocation à la coopération internationale ; qualité de la formation ; promotion de l'esprit d'entreprise.
              </p>
              <Button variant="ghost" size="sm" onClick={() => navigate("/valeurs")} className="text-primary p-0 h-auto font-semibold">
                Nos Valeurs <ArrowRight className="w-4 h-4 ml-1 inline" />
              </Button>
            </div>

            <div>
              <h3 className="text-lg font-bold text-foreground mb-2">I.4. Objectifs</h3>
              <p className="text-muted-foreground font-medium mb-2">Objectif global :</p>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Contribuer à l'amélioration des conditions de vie de la population et à la réduction de la pauvreté à travers la formation universitaire, la recherche scientifique et l'innovation.
              </p>
              <p className="text-muted-foreground font-medium mb-2">Objectifs spécifiques :</p>
              <ul className="list-disc list-inside text-muted-foreground space-y-1">
                <li>Promouvoir l'offre académique (nouvelles facultés, départements et instituts).</li>
                <li>Renforcer la culture de paix sociale et de réconciliation.</li>
                <li>Contribuer à la formation intégrale des étudiants.</li>
                <li>Renforcer les capacités du personnel enseignant.</li>
                <li>Promouvoir la recherche scientifique innovante.</li>
                <li>Améliorer les infrastructures d'enseignement et les laboratoires.</li>
                <li>Développer des partenariats publics et privés.</li>
                <li>Promouvoir le développement rural.</li>
                <li>Intégrer les TIC dans l'enseignement et la gestion.</li>
                <li>Renforcer l'insertion professionnelle des diplômés.</li>
                <li>Améliorer la qualité de vie du personnel.</li>
                <li>Promouvoir un modèle de gestion participatif et transparent.</li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-bold text-foreground mb-3">I.5. Organes de l'Université</h3>
              <ul className="space-y-2">
                {ORGANES.map((organe, i) => (
                  <li key={i} className="flex items-center gap-3 text-muted-foreground">
                    <span className="w-6 h-6 rounded-full bg-primary/10 text-primary text-sm font-bold flex items-center justify-center flex-shrink-0">{i + 1}</span>
                    {organe}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>

        {/* Sigles */}
        <section className="mb-20 scroll-mt-24" id="sigles">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-1 bg-accent rounded-full" />
            <span className="text-[11px] uppercase tracking-[0.3em] font-bold text-accent">Référence</span>
          </div>
          <h2 className="text-2xl font-serif font-bold text-foreground mb-6">Sigles et Abréviations</h2>
          <div className="overflow-x-auto -mx-2">
            <table className="w-full min-w-[500px] border-collapse text-left">
              <thead>
                <tr className="border-b-2 border-primary">
                  <th className="py-3 px-4 font-bold text-foreground">Sigle</th>
                  <th className="py-3 px-4 font-bold text-foreground">Désignation complète</th>
                </tr>
              </thead>
              <tbody>
                {SIGLES.map((row, i) => (
                  <tr key={i} className="border-b border-border hover:bg-secondary/30 transition-colors">
                    <td className="py-3 px-4 font-semibold text-primary">{row.sigle}</td>
                    <td className="py-3 px-4 text-muted-foreground">{row.designation}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        {/* Partenariats académiques */}
        <section className="mb-20 scroll-mt-24" id="partenariats-academiques">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-1 bg-primary rounded-full" />
            <span className="text-[11px] uppercase tracking-[0.3em] font-bold text-primary">Conventions</span>
          </div>
          <h2 className="text-2xl font-serif font-bold text-foreground mb-2">Partenariats Académiques, Scientifiques et de Coopération</h2>
          <p className="text-muted-foreground mb-6">
            Au cours des dernières années, l'Université de Ngozi a signé plusieurs conventions de collaboration avec des institutions locales, nationales et internationales.
          </p>
          <div className="overflow-x-auto -mx-2 rounded-lg border border-border">
            <table className="w-full min-w-[640px] border-collapse text-left text-sm">
              <thead>
                <tr className="bg-secondary/50 border-b border-border">
                  <th className="py-3 px-4 font-bold text-foreground w-12">N°</th>
                  <th className="py-3 px-4 font-bold text-foreground">Convention</th>
                  <th className="py-3 px-4 font-bold text-foreground">Objectif global</th>
                  <th className="py-3 px-4 font-bold text-foreground">Date</th>
                  <th className="py-3 px-4 font-bold text-foreground">Durée</th>
                </tr>
              </thead>
              <tbody>
                {PARTENARIATS_ACADEMIQUES.map((row) => (
                  <tr key={row.n} className="border-b border-border hover:bg-secondary/20 transition-colors">
                    <td className="py-3 px-4 font-semibold text-primary">{row.n}</td>
                    <td className="py-3 px-4 text-foreground">{row.convention}</td>
                    <td className="py-3 px-4 text-muted-foreground">{row.objectif}</td>
                    <td className="py-3 px-4 text-muted-foreground whitespace-nowrap">{row.date}</td>
                    <td className="py-3 px-4 text-muted-foreground">{row.duree}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        {/* Partenariats institutionnels */}
        <section className="mb-20 scroll-mt-24" id="partenariats-institutionnels">
          <h2 className="text-2xl font-serif font-bold text-foreground mb-6">Partenariats Institutionnels et Professionnels</h2>
          <div className="overflow-x-auto -mx-2 rounded-lg border border-border">
            <table className="w-full min-w-[560px] border-collapse text-left text-sm">
              <thead>
                <tr className="bg-secondary/50 border-b border-border">
                  <th className="py-3 px-4 font-bold text-foreground w-12">N°</th>
                  <th className="py-3 px-4 font-bold text-foreground">Convention</th>
                  <th className="py-3 px-4 font-bold text-foreground">Objectif global</th>
                  <th className="py-3 px-4 font-bold text-foreground">Date</th>
                </tr>
              </thead>
              <tbody>
                {PARTENARIATS_INSTITUTIONNELS.map((row) => (
                  <tr key={row.n} className="border-b border-border hover:bg-secondary/20 transition-colors">
                    <td className="py-3 px-4 font-semibold text-primary">{row.n}</td>
                    <td className="py-3 px-4 text-foreground">{row.convention}</td>
                    <td className="py-3 px-4 text-muted-foreground">{row.objectif}</td>
                    <td className="py-3 px-4 text-muted-foreground whitespace-nowrap">{row.date}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        {/* Conclusion */}
        <section className="pt-12 border-t border-border">
          <div className="max-w-3xl">
            <p className="text-lg text-muted-foreground leading-relaxed mb-6">
              Depuis plus de 25 ans, l'Université de Ngozi demeure un acteur majeur de l'excellence académique au Burundi. Par sa vision, ses missions et ses partenariats stratégiques, elle continue de rayonner dans les domaines de la formation, de la recherche et du développement communautaire.
            </p>
            <p className="text-lg text-muted-foreground leading-relaxed">
              Ces conventions de partenariat renforcent sa contribution à la construction d'un avenir prospère et durable pour la jeunesse et pour le pays.
            </p>
          </div>
        </section>

        {/* Quick links */}
        <nav className="mt-16 flex flex-wrap gap-4" aria-label="Pages liées">
          <Button variant="outline" onClick={() => navigate("/mission")} className="border-primary text-primary hover:bg-primary hover:text-primary-foreground">
            <BookOpen className="w-4 h-4 mr-2" />
            Mission & Vision
          </Button>
          <Button variant="outline" onClick={() => navigate("/valeurs")} className="border-primary text-primary hover:bg-primary hover:text-primary-foreground">
            <FileText className="w-4 h-4 mr-2" />
            Nos Valeurs
          </Button>
          <Button variant="outline" onClick={() => navigate("/historique")} className="border-primary text-primary hover:bg-primary hover:text-primary-foreground">
            <Building2 className="w-4 h-4 mr-2" />
            Historique
          </Button>
        </nav>
      </div>

      {/* Footer CTA */}
      <footer className="bg-primary text-primary-foreground py-16 border-t-8 border-accent">
        <div className="container max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-2xl font-serif font-bold mb-4">Partenariats au service de l'excellence</h2>
          <p className="text-primary-foreground/90 mb-8 max-w-xl mx-auto">
            Découvrez notre mission, notre vision et nos campus pour mieux nous connaître.
          </p>
          <Button onClick={() => navigate("/mission")} className="bg-accent text-accent-foreground hover:bg-accent/90 font-semibold">
            Mission & Vision
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </div>
      </footer>
    </div>
  )
}
